import { Avatar } from "@whoosh/design-system/src/components/display";
import { Text, HStack } from "@whoosh/design-system/src/components/primitive";

type Props = {
  firstName: string | null;
  lastName: string | null;
};

export const JoiningUserRow = ({ firstName, lastName }: Props) => {
  return (
    <HStack alignItems="center" gap={3}>
      <Avatar
        firstName={firstName}
        lastName={lastName}
        size="tiny"
        testID="avatar-joining-user-row"
      />
      <Text
        testID="joining-user-row-name"
        variant="mainBaseSemiBold"
      >{`${firstName} ${lastName}`}</Text>
    </HStack>
  );
};
